var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29420_36354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.874831 0.952509C-0.225335 2.09526 -0.000168598 3.30918 -0.000168598 6.99701C-0.000168598 10.0595 -0.534502 13.1296 2.262 13.8523C3.13525 14.0769 10.8726 14.0769 11.7447 13.8512C12.909 13.5508 13.8563 12.6063 13.9858 10.9596C14.0039 10.7298 14.0039 3.26834 13.9852 3.03384C13.8476 1.27976 12.7678 0.268842 11.3451 0.064092C11.019 0.016842 10.9537 0.002842 9.28066 -7.46624e-05C3.34641 0.002842 2.04558 -0.261408 0.874831 0.952509Z",
    fill: "url(#paint0_linear_29420_36354)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99889 1.83116C4.8808 1.83116 2.86947 1.64274 2.10122 3.61441C1.78389 4.42874 1.82997 5.48633 1.82997 7.00066C1.82997 8.32949 1.78739 9.57841 2.10122 10.3863C2.86772 12.3592 4.89539 12.1702 6.99772 12.1702C9.02597 12.1702 11.1172 12.3813 11.8948 10.3863C12.2127 9.56383 12.1661 8.52199 12.1661 7.00066C12.1661 4.98116 12.2775 3.67741 11.2981 2.69858C10.3064 1.70691 8.9653 1.83116 6.99655 1.83116H6.99889ZM6.53572 2.76274C10.9539 2.75574 11.5162 2.26458 11.2059 9.08783C11.0956 11.5011 9.25814 11.2362 6.99947 11.2362C2.88114 11.2362 2.76272 11.1184 2.76272 6.99833C2.76272 2.83041 3.08939 2.76508 6.53572 2.76158V2.76274ZM9.75805 3.62083C9.41564 3.62083 9.13797 3.89849 9.13797 4.24091C9.13797 4.58333 9.41564 4.86099 9.75805 4.86099C10.1005 4.86099 10.3781 4.58333 10.3781 4.24091C10.3781 3.89849 10.1005 3.62083 9.75805 3.62083ZM6.99889 4.34591C5.53297 4.34591 4.34472 5.53474 4.34472 7.00066C4.34472 8.46658 5.53297 9.65483 6.99889 9.65483C8.4648 9.65483 9.65247 8.46658 9.65247 7.00066C9.65247 5.53474 8.4648 4.34591 6.99889 4.34591ZM6.99889 5.27749C9.2768 5.27749 9.27972 8.72383 6.99889 8.72383C4.72155 8.72383 4.71805 5.27749 6.99889 5.27749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29420_36354",
    x1: 0.901676,
    y1: 13.1057,
    x2: 13.9132,
    y2: 1.84441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29420_36354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagramIcon);
export default __webpack_public_path__ + "static/media/Social_InstagramIcon.cde7b92533cb3bf9516e6a6839fbabbf.svg";
export { ForwardRef as ReactComponent };